import React from 'react'

export default () => {
    return (
        <main className={`Newlsetter`}>

        </main>
    )
}